
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations/';
import { NgModule } from '@angular/core';
import { routing } from './app.routing';
import { AppComponent } from './app.component';
import { LayoutModule } from './@theme/layout/layout.module';
import { TeacherService } from './shared/services/teacher.services';
import { JwtService } from './shared/services/jwt.service';
import { ApiService } from './shared/services/api.service';
import { GlobalState } from './shared/global.state';
import { UserService } from './shared/services/user.service';
import { CommonService } from './shared/services/common.service';
import { AuthGuardService } from './shared/services/auth-guard.service';
import { NoGuardService } from './shared/services/no-guard.service';
import { RedirectGuardService } from './shared/services/redirect-guard.service';
import { AssessmentComponent } from './assessment/assessment.component';
import { ApiServiceAssessment } from './assessment/service';

@NgModule({
  declarations: [
    AppComponent,
    AssessmentComponent
  ],
  imports: [
    routing,
    BrowserModule,
    LayoutModule,
    BrowserAnimationsModule,
  ],
  bootstrap: [AppComponent],
  providers: [
    JwtService,
    ApiService,
    ApiServiceAssessment,
    UserService,
    TeacherService,
    GlobalState,
    CommonService,
    AuthGuardService,
    NoGuardService,
    RedirectGuardService,
  ]
})
export class AppModule { }
